import { FC } from 'react';
import { Navigate, useNavigate } from '@tanstack/react-router';
import { ContentLoader } from '@frontend/design-system';
import { useGetWritebackCapabilities } from '../../../hooks/api-hooks';
import { KioskTypes } from '../../../types';
import { KioskLayout } from '../components';
import { WelcomePageContent } from './components/welcome-page-content';
import { KioskHomeContextProps, KioskHomeWrapper } from './provider';

export const KioskHome: FC<KioskHomeContextProps> = ({ locationId }) => {
  const { hasWritebackIntegration, isLoading } = useGetWritebackCapabilities(locationId);
  const navigate = useNavigate();

  const navigateToKioskFormsPage = (patientType: KioskTypes.Patron) =>
    navigate({ to: `/kiosk/forms/${locationId}`, search: { patientType } });

  if (isLoading) return <ContentLoader show />;

  if (!hasWritebackIntegration) {
    return <Navigate to={`/kiosk/forms/${locationId}`} />;
  }

  return (
    <KioskHomeWrapper locationId={locationId}>
      <KioskLayout locationId={locationId}>
        <WelcomePageContent onSelectPatientType={navigateToKioskFormsPage} />
      </KioskLayout>
    </KioskHomeWrapper>
  );
};
